<!-- Container-fluid starts-->
<div class="container-fluid reports-by-user">
  <div class="row pl-3 mb-3">
    <ul class="filter-list">
      <li class="list-filter active">
        Total de reportes ({{total != null ? total : 0}})
      </li>
    </ul>
  </div>

  <div class="reports-grid" *ngIf="reportsList.length > 0">
    <div *ngFor="let report of reportsList" class="report-card">
      <div class="report-card__header">
        <span class="report-card__folio">Folio {{report.folio}}</span>
        <span class="report-card__status">{{report.Status}}</span>
      </div>
      <div class="report-card__body">
        <p class="report-card__date">
          <i class="fa fa-calendar"></i>
          {{report.created_at | date:'dd/MM/yyyy h:mm:ss a'}}
        </p>
        <p class="report-card__area">
          <i class="fa fa-building"></i>
          {{report.Department ? report.Department : 'Sin área asignada'}}
        </p>
        <p class="report-card__name">
          <i class="fa fa-user"></i>
          {{report.Name}}
        </p>
      </div>
      <button type="button" class="btn btn-primary report-card__btn" (click)="openReportDetail(report.id)">
        Ver
      </button>
    </div>
  </div>

  <div class="empty-state" *ngIf="!loading && reportsList.length === 0 && statusFilters.length > 0">
    <p>No se han encontrado reportes.</p>
  </div>

  <div class="loading-more" *ngIf="loading">
    <span>Cargando más reportes...</span>
  </div>

  <div class="end-message" *ngIf="!loading && reportsList.length > 0 && !hasMore">
    <span>Has visto todos los reportes ({{total}} en total)</span>
  </div>
</div>

<!-- Modal detalle del reporte -->
<ng-template #reportDetailModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Detalle del reporte</h5>
    <button type="button" class="close" aria-label="Cerrar" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" *ngIf="loadingDetail">
    <p class="text-center">Cargando...</p>
  </div>
  <div class="modal-body report-detail-content" *ngIf="!loadingDetail && selectedReport">
    <table class="table table-sm">
      <tbody>
        <tr><td class="som">Nº de reporte:</td><td>{{selectedReport.Folio || selectedReport.folio}}</td></tr>
        <tr><td class="som">Fecha:</td><td>{{selectedReport.created_at | date:'dd/MM/yyyy, h:mm a'}}</td></tr>
        <tr><td class="som">Fuente:</td><td>{{selectedReport.Source || 'Invitado'}}</td></tr>
        <tr><td class="som">Estatus:</td><td>{{selectedReport.Status}}</td></tr>
        <tr><td class="som">Nombre:</td><td>{{selectedReport.Name}}</td></tr>
        <tr><td class="som">Teléfono:</td><td>{{selectedReport.PhoneNumber || 'Sin número'}}</td></tr>
        <tr><td class="som">Correo:</td><td>{{selectedReport.Email}}</td></tr>
        <tr><td class="som">Problema:</td><td>{{selectedReport.Subject}}</td></tr>
        <tr><td class="som">Descripción:</td><td>{{selectedReport.Description}}</td></tr>
        <tr><td class="som">Área asignada:</td><td>{{selectedReport.Department || 'Sin área asignada'}}</td></tr>
      </tbody>
    </table>

    <div class="report-detail__photo" *ngIf="selectedReport.ImgBase64 || selectedReport.ImgUrl">
      <strong class="report-detail__section-title">Fotografía del reporte</strong>
      <img [src]="selectedReport.ImgBase64 || selectedReport.ImgUrl" alt="Fotografía del reporte" class="img-fluid">
    </div>

    <div class="report-detail__map-section" *ngIf="selectedReport.Address && selectedReport.Address.Location">
      <strong class="report-detail__section-title">Ubicación</strong>
      <agm-map class="report-detail__map"
        [latitude]="selectedReport.Address.Location.lat"
        [longitude]="selectedReport.Address.Location.lng"
        [scrollwheel]="true"
        [zoom]="16">
        <agm-marker
          [latitude]="selectedReport.Address.Location.lat"
          [longitude]="selectedReport.Address.Location.lng">
        </agm-marker>
      </agm-map>
    </div>

    <div class="report-detail__address" *ngIf="selectedReport.Address">
      <strong class="report-detail__section-title">Dirección</strong>
      <p *ngIf="selectedReport.Address.Street">{{selectedReport.Address.Street}}</p>
      <p *ngIf="selectedReport.Address.ExtNumber">Núm. ext: {{selectedReport.Address.ExtNumber}}</p>
      <p *ngIf="selectedReport.Address.Neighborhood">Col. {{selectedReport.Address.Neighborhood}}</p>
      <p *ngIf="selectedReport.Address.ZipCode">CP {{selectedReport.Address.ZipCode}}</p>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cerrar</button>
  </div>
</ng-template>
<!-- Container-fluid Ends-->